import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CaptchaComponent} from './captcha.component';
import { RecaptchaModule } from 'ng-recaptcha';



@NgModule({
  declarations: [CaptchaComponent],
  exports: [
    CaptchaComponent
  ],
  imports: [
    CommonModule,
    RecaptchaModule,
  ]
})
export class CaptchaModule { }
